import { render, staticRenderFns } from "./ReviewBoxContent.vue?vue&type=template&id=13d9f8db&scoped=true&lang=pug&"
import script from "./ReviewBoxContent.vue?vue&type=script&lang=ts&"
export * from "./ReviewBoxContent.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewBoxContent.vue?vue&type=style&index=0&id=13d9f8db&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9f8db",
  null
  
)

export default component.exports